module.exports = {"620823001":"锦屏街道办","620823100":"锦屏镇","620823101":"新窑镇","620823102":"柏树镇","620823103":"黄寨镇","620823202":"黄花乡","620823203":"木林乡","620823400":"崇信县新窑工业园区管理委员会","620823401":"五举农场","620823402":"崇信县铜城工业园区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620823.json
// module id = 2927
// module chunks = 0